// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datetime-picker-v2-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.datetime-picker-v2-wrapper.is-invalid .datetime-picker-v2 ::ng-deep .mdc-text-field--filled {
  border-color: #d33;
}

.datetime-picker-v2-error {
  color: #d33;
  font-size: 12px;
  line-height: 1.2;
}

.datetime-picker-v2 {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}
.datetime-picker-v2 .date-field {
  flex: 1 1 auto;
  min-width: 160px;
  max-width: 170px;
  width: 100%;
  position: relative;
}
.datetime-picker-v2 .time-field {
  flex: 0 0 130px;
  max-width: 130px;
  position: relative;
}
.datetime-picker-v2 ::ng-deep .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  height: 38px;
}
.datetime-picker-v2 ::ng-deep .mat-mdc-form-field .mdc-text-field--filled {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  overflow: hidden;
  padding: 0 4px 0 12px;
}
.datetime-picker-v2 ::ng-deep .mat-mdc-form-field .mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: #fff;
}
.datetime-picker-v2 ::ng-deep .mat-mdc-form-field .mdc-text-field--filled.mdc-text-field--disabled {
  background-color: #e9ecef;
}
.datetime-picker-v2 ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-infix {
  padding-top: 0;
  padding-bottom: 0;
  min-height: auto;
}
.datetime-picker-v2 ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-flex {
  align-items: center;
  height: 100%;
}
.datetime-picker-v2 ::ng-deep .mat-mdc-form-field .mdc-text-field__input {
  padding-top: 0;
  padding-bottom: 0;
  font-size: 13px;
}
.datetime-picker-v2 ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-icon-suffix {
  padding: 0;
}
.datetime-picker-v2 ::ng-deep .mat-mdc-form-field .mat-mdc-icon-button {
  width: 28px;
  height: 28px;
  padding: 0;
}
.datetime-picker-v2 ::ng-deep .mat-mdc-form-field .mat-mdc-icon-button .mat-mdc-button-touch-target {
  width: 28px;
  height: 28px;
}
.datetime-picker-v2 ::ng-deep .mat-mdc-form-field .mat-mdc-icon-button .mat-icon,
.datetime-picker-v2 ::ng-deep .mat-mdc-form-field .mat-mdc-icon-button svg {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}
.datetime-picker-v2 ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.datetime-picker-v2 ::ng-deep .mat-mdc-form-field .dt-clear-btn {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #888;
  font-size: 16px;
  line-height: 18px;
  z-index: 1;
}
.datetime-picker-v2 ::ng-deep .mat-mdc-form-field .dt-clear-btn:hover {
  color: #333;
}
.datetime-picker-v2 ::ng-deep .mat-mdc-form-field .mdc-line-ripple {
  display: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
